import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

const TeacherDetailPage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        const { data, error } = await supabase
          .from('Teachers')
          .select('*')
          .eq('uuid_id', uuid)
          .single();

        if (error) {
          console.error('Error fetching teacher:', error);
          navigate('/dashboard/student/teachers');
          return;
        }

        setTeacher(data);
      } catch (err) {
        console.error('Error:', err);
        navigate('/dashboard/student/teachers');
      } finally {
        setLoading(false);
      }
    };

    fetchTeacher();
  }, [uuid, navigate]);

  useEffect(() => {
    // Redirect to calendar page with teacher pre-selected
    if (teacher) {
      console.log('🔍 TeacherDetailPage: Navigating to calendar with teacher:', teacher);
      navigate('/dashboard/student/calendar', {
        state: { teacher: teacher },
        replace: true
      });
    }
  }, [teacher, navigate]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return null;
};

export default TeacherDetailPage;